import React, { useCallback } from 'react';
import { Graphics } from '@pixi/react';

const ClosedShape = ({ shape, zIndex = 0 }) => {
  const drawShape = useCallback((g) => {
    if (!shape || !shape.vertices || shape.vertices.length < 3) return;

    g.clear();
    g.lineStyle(4, 0x1976d2); // Bold blue border
    // Convert hex color to PIXI color
    const hexColor = shape.fillColor || '#e3f2fd';
    const color = parseInt(hexColor.replace('#', ''), 16);
    g.beginFill(color, 0.5); // More prominent fill
    // Draw the polygon
    const firstVertex = shape.vertices[0];
    g.moveTo(firstVertex.x, firstVertex.y);
    for (let i = 1; i < shape.vertices.length; i++) {
      const vertex = shape.vertices[i];
      g.lineTo(vertex.x, vertex.y);
    }
    // Close the polygon
    g.lineTo(firstVertex.x, firstVertex.y);
    g.endFill();
  }, [shape]);

  return (
    <Graphics
      draw={drawShape}
      interactive={false}
      zIndex={zIndex}
    />
  );
};

export default ClosedShape; 